import { render, staticRenderFns } from "./VideoRequests-Admin.vue?vue&type=template&id=2c40ba99&scoped=true"
import script from "./VideoRequests-Admin.js?vue&type=script&lang=js&external"
export * from "./VideoRequests-Admin.js?vue&type=script&lang=js&external"
import style0 from "./VideoRequests-Admin.vue?vue&type=style&index=0&id=2c40ba99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40ba99",
  null
  
)

export default component.exports